import type { PortableTextTypeComponent } from '@portabletext/react';

import ResourceBlockComponent, { type ResourceBlockProps } from '@helsenorge/core-cms/behandlingsvalg/ressursblock';

export interface ResourceBlockType extends ResourceBlockProps {
  _type: 'ResourceBlock';
}

const ResourceBlock: PortableTextTypeComponent<ResourceBlockType> = ({ value }) => <ResourceBlockComponent {...value} />;

export default ResourceBlock;
